<template>
  <el-select
    v-if="options.values"
    v-model="searchValue"
    :placeholder="options.label"
    :size="size"
    filterable
    clearable
    :multiple="options.multiple"
    style="width: 100%"
    @change="onSearch"
  >
    <el-option
      v-for="(item, index) in options.values"
      :key="index"
      :label="item.label"
      :value="item.code"
    />
  </el-select>
  <DateTimePicker
    v-else-if="options.format === 'datetimerange'"
    v-model="searchValue"
    type="datetimerange"
    :size="size"
    @change="onSearch"
  />
  <DateTimePicker
    v-else-if="options.format === 'daterange'"
    v-model="searchValue"
    type="daterange"
    :size="size"
    @change="onSearch"
  />

  <el-input
    v-else
    v-model="searchValue"
    :size="size"
    :placeholder="options.label || `Поиск`"
    :title="options.label || `Поиск`"
    @change="onSearch"
    @keyup.native="onKeyup"
  />
</template>

<script>
import { updateQuery } from "@/utils/index";

import DateTimePicker from "@/components/TableSearchDatePicker";

export default {
  name: "TableSearch",
  components: {
    DateTimePicker,
  },
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    size: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      searchValue: "",
    };
  },
  async created() {
    this.setSearchValueOfQuery();
  },
  methods: {
    setSearchValueOfQuery() {
      const { name } = this.options;
      const { query } = this.$route;

      if (Array.isArray(name)) {
        this.searchValue = [query[name[0]], query[name[1]]];
      } else if (query[name]) {
        this.searchValue = query[name];

        if (this.searchValue[0] === "%")
          this.searchValue = this.searchValue.slice(1); // удаляем первый %
        if (this.searchValue[this.searchValue.length - 1] === "%")
          this.searchValue = this.searchValue.slice(0, -1); // удаляем последний %
      }
    },
    getDateTimeRange(names, values) {
      const dateFrom = values[0] ? values[0] : undefined;
      const dateTo = values[1] ? values[1] : undefined;

      return {
        [names[0]]: dateFrom,
        [names[1]]: dateTo,
      };
    },
    onSearch(value) {
      const { type, format, name } = this.options;
      if (this.options.single) {
        this.$emit("searchSingle", value);
        return;
      }
      if (!value) {
        updateQuery.call(this, { [this.options.name]: undefined });
        return;
      }
      if (format === "datetimerange" || format == "daterange") {
        updateQuery.call(this, this.getDateTimeRange(name, this.searchValue));
        return;
      }
      if (type === "list") {
        const list = value.split(",");
        updateQuery.call(this, { [this.options.name]: list.map((e) => e) });
        return;
      }
      if (type === "array") {
        updateQuery.call(this, { [this.options.name]: value.map((e) => e) });
        return;
      }
      const query = this.options.strong ? value : `%${value}%`;
      updateQuery.call(this, { [this.options.name]: query });
    },
    onKeyup(e) {
      this.$emit("quickFilter", {
        name: this.options.name,
        value: e.target.value,
        key: e.code,
      });
    },
  },
};
</script>
